import { render } from "./UiButtonOk.vue?vue&type=template&id=040a6c42&scoped=true"
import script from "./UiButtonOk.vue?vue&type=script&lang=js"
export * from "./UiButtonOk.vue?vue&type=script&lang=js"

import "./UiButtonOk.vue?vue&type=style&index=0&id=040a6c42&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040a6c42"]])

export default __exports__